import React, { useRef, useEffect } from 'react'
import DefaultLayout from '../components/DefaultLayout'
import or from "../assets/ORFace2.png"
import bs5 from "../assets/bootstrap-5-1.svg"
import css from "../assets/css.png"
import html from "../assets/html5-12.png"
import js from "../assets/JavaScript-logo.png"
import njs from "../assets/nodejs.png"
import git from "../assets/github.png"
import linkedIN from "../assets/linkedin.png"
import gmail from "../assets/icons8-gmail-144.png"
import light from "../assets/light.png"
import fig from "../assets/Figma-1-logo.png"
import sktch from "../assets/Sketch_Logo.svg.png"
import RHOS from "../assets/RH-OS.png"
import aws from "../assets/aws.png"
import n8n from "../assets/n8n.png"
import supa from "../assets/Supabase Logo - Colored.png"
import elev from "../assets/elevenLabs.png"
import xd from "../assets/adobe-xd-logo-png-transparent.png"
import strp from "../assets/Stripe-Emblem.png"
import shpfy from "../assets/shopify-partner-logo.png"
import sqr from "../assets/square Logo.png"
import mdb from "../assets/mongodb.png"
import { Divider } from 'antd'
import { Typewriter } from 'react-simple-typewriter'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';

function Home() {

    return (
        <DefaultLayout>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 pt-5'>
                        <h1><b>Odis Reese</b></h1>
                        <div className="flex">
                            <h3 className='color'><Typewriter words={['UI/UX Designer.', 'Front End Developer;', 'UX Researcher.', 'AWS Cloud Architect.', 'AI Engineer.', 'Entrepreneur.', 'Business Owner.']} cursor loop={false} /></h3>
                        </div>
                        {/* <h3>Developer;<br />designer.<br />Business Strategist</h3> */}
                        <p>A dedicated individual who always strives to work on end to end products which develop sustainable, inovative, and scalable technial systems to create impact.</p>
                        <div className='pb-4'>
                            <a href='https://github.com/oreese95' target="_blank"><img src={git} width="35" /></a>&nbsp;&nbsp;&nbsp;
                            <a href="mailto:Reese.Odis29@Gmail.com" target="_blank"><img src={gmail} width="35" /></a>&nbsp;&nbsp;&nbsp;
                            <a href="https://www.linkedin.com/in/odisreese/" target="_blank"><img src={linkedIN} width="35" /></a>
                        </div>
                    </div><br /><br />
                    <div className='col-lg-6 d-flex justify-content-center'>
                        <img src={or} width="430" />
                    </div>
                </div>
                <div className='row m-5'>
                    <div className='col-lg-12'>
                        <h3><b>What I Build</b></h3>
                    </div>
                </div>
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: false,
                    }}
                    pagination={true}
                    modules={[EffectCoverflow, Pagination]}
                    className="mySwiper Main"
                >
                    <SwiperSlide className='mySMain'>
                        <div className='row m-3 flex justify-content-center'>
                            <div className='col-lg-12 bxs p-3 onBig'>
                                <h4>AI Engineering &amp; Automation</h4>
                                <Divider style={{ backgroundColor: "dodgerblue" }} />
                                <div className=''>
                                    <img className='m-1' src={elev} width="110" />
                                    <img className='m-1' src={n8n} width="110" />
                                </div>
                                <p>LLMs &middot; AI Agents &middot; Voice AI &middot; Workflow Automation</p>
                                <p><img src={light} width="25" />Build LLM-powered applications and intelligent assistants</p>
                                <p><img src={light} width="25" />Design agents that connect to APIs, tools, and business data</p>
                                <p><img src={light} width="25" />Automate workflows using AI, triggers, and integrations</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='mySMain'>
                        <div className='row m-3 flex justify-content-center'>
                            <div className='col-lg-12 bxs p-3 onBig'>
                                <h4>Full-Stack Development</h4>
                                <Divider style={{ backgroundColor: "dodgerblue" }} />
                                <div className=''>
                                    <img className='m-1' src={html} width="50" />
                                    <img className='m-1' src={css} width="50" />
                                    <img className='m-1' src={js} width="50" />
                                    <img className='m-1' src={bs5} width="50" />
                                    <img className='m-1' src={njs} width="110" />
                                    <img className='m-1' src={supa} width="140" />
                                </div>
                                <p>React &middot; TypeScript &middot; HTML/CSS &middot; Node.js &middot; Supabase &middot; APIs</p>
                                <p><img src={light} width="25" />Build responsive web applications from frontend to backend</p>
                                <p><img src={light} width="25" />Develop APIs, databases, authentication, and integrations</p>
                                <p><img src={light} width="25" />Deploy and maintain production-ready applications</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='mySMain'>
                        <div className='row m-3 flex justify-content-center'>
                            <div className='col-lg-12 bxs p-3 onBig'>
                                <h4>Product Design &amp; UX</h4>
                                <Divider style={{ backgroundColor: "dodgerblue" }} />
                                <div className=''>
                                    <img className='m-1' src={fig} width="50" />
                                    <img className='m-1' src={sktch} width="50" />
                                    <img className='m-1' src={xd} width="50" />
                                </div>
                                <p>Figma &middot; Design Systems &middot; Prototyping &middot; Accessibility</p>
                                <p><img src={light} width="25" />Deploy and maintain production-ready applications</p>
                                <p><img src={light} width="25" />Translate complex workflows into simple user journeys</p>
                                <p><img src={light} width="25" />Create wireframes, prototypes, design systems, and UI kits</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='mySMain'>
                        <div className='row m-3 flex justify-content-center'>
                            <div className='col-lg-12 bxs p-3 onBig'>
                                <h4>Cloud &amp; Systems</h4>
                                <Divider style={{ backgroundColor: "dodgerblue" }} />
                                <div className=''>
                                    <img className='m-1' src={aws} width="70" />
                                    <img className='m-1' src={RHOS} width="150" />
                                    <img className='m-1' src={mdb} width="150" />
                                </div>
                                <p>AWS &middot; OpenShift &middot; APIs &middot; CI/CD</p>

                                <p><img src={light} width="25" />Deploy and maintain applications in cloud environments</p>
                                <p><img src={light} width="25" />Connect databases, APIs, services, and third-party platforms</p>
                                <p><img src={light} width="25" />Build scalable application infrastructure and deployment workflows</p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='mySMain'>
                        <div className='row m-3 flex justify-content-center'>
                            <div className='col-lg-12 bxs p-3 onBig'>
                                <h4>Business Systems</h4>
                                <Divider style={{ backgroundColor: "dodgerblue" }} />
                                <div>
                                    <img className='m-1' src={shpfy} width="150" />
                                    <img className='m-1' src={strp} width="80" />
                                    <img className='m-1' src={sqr} width="50" />
                                </div>
                                <p>E-Commerce &middot; Digital Strategy &middot; Business Systems &middot; Growth &amp; Automation</p>
                                <p><img src={light} width="25" />Design digital experiences around business objectives</p>
                                <p><img src={light} width="25" />Develop e-commerce and online business solutions</p>
                                <p><img src={light} width="25" />Connect technology, automation, and customer workflows</p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>

                {/* 
                
                
                 */}
            </div>
        </DefaultLayout >
    )
}

export default Home